import { Injectable } from '@angular/core';

const CURRENCY_FORMATTER = new Intl.NumberFormat('pt-BR', {
  style: 'currency',
  currency: 'BRL'
});
const DATE_FORMATTER = new Intl.DateTimeFormat('pt-BR');
const TIME_FORMATTER = new Intl.DateTimeFormat('pt-BR', {
  hour: '2-digit',
  minute: '2-digit',
  second: '2-digit'
});

@Injectable({
  providedIn: 'root',
})
export class FormatterHelperService {
  moeda(valor: number | string | null | undefined): string {
    if (valor === null || valor === undefined || (typeof valor === 'string' && valor.trim() === '')) {
      return '-';
    }

    const numericValue = typeof valor === 'number' ? valor : Number(valor);
    return Number.isFinite(numericValue) ? CURRENCY_FORMATTER.format(numericValue) : '-';
  }

  data(data: string | Date | null | undefined): string {
    const date = this.parseDate(data);
    return date ? DATE_FORMATTER.format(date) : '-';
  }

  dataHora(data: string | Date | null | undefined): string {
    const date = this.parseDate(data);
    return date ? `${DATE_FORMATTER.format(date)} ${TIME_FORMATTER.format(date)}` : '-';
  }

  CPF(cpf: string | null | undefined): string {
    if (!cpf?.trim()) return '-';

    const digits = cpf.replace(/\D/g, '');
    if (digits.length !== 11) return cpf;

    return `${digits.slice(0, 3)}.${digits.slice(3, 6)}.${digits.slice(6, 9)}-${digits.slice(9)}`;
  }

  celular(celular: string | null | undefined): string {
    return this.telefone(celular);
  }

  telefone(telefone: string | null | undefined): string {
    if (!telefone?.trim()) return '-';

    const digits = telefone.replace(/\D/g, '');
    if (digits.length === 10) {
      return `(${digits.slice(0, 2)}) ${digits.slice(2, 6)}-${digits.slice(6)}`;
    }
    if (digits.length === 11) {
      return `(${digits.slice(0, 2)}) ${digits.slice(2, 7)}-${digits.slice(7)}`;
    }

    return telefone;
  }

  CEP(cep: string | number | null | undefined): string {
    if (cep === null || String(cep).trim() === '') return '-';

    const digits = String(cep).replace(/\D/g, '');

    return digits.length === 8 ? `${digits.slice(0, 5)}-${digits.slice(5)}` : String(cep);
  }

  private parseDate(value: string | Date | null | undefined): Date | null {
    if (value instanceof Date) {
      return Number.isNaN(value.getTime()) ? null : value;
    }

    const normalizedValue = value?.trim();
    if (!normalizedValue) return null;

    const isoDate = /^(\d{4})-(\d{2})-(\d{2})$/.exec(normalizedValue);
    if (isoDate) {
      return this.createLocalDate(Number(isoDate[1]), Number(isoDate[2]), Number(isoDate[3]));
    }

    const brazilianDate = /^(\d{2})\/(\d{2})\/(\d{4})$/.exec(normalizedValue);
    if (brazilianDate) {
      return this.createLocalDate(
        Number(brazilianDate[3]),
        Number(brazilianDate[2]),
        Number(brazilianDate[1])
      );
    }

    const parsedDate = new Date(normalizedValue);
    return Number.isNaN(parsedDate.getTime()) ? null : parsedDate;
  }

  private createLocalDate(year: number, month: number, day: number): Date | null {
    const date = new Date(year, month - 1, day);
    if (date.getFullYear() !== year || date.getMonth() !== month - 1 || date.getDate() !== day) {
      return null;
    }

    return date;
  }
}
